module.exports = __webpack_public_path__ + "img/tettwo.a835d407.jpg";